export { default } from './Search.Component'
export type { SearchProps } from './Search.Component'



// WEBPACK FOOTER //
// ./src/components/Layout/Search/index.ts